import { Empty } from 'antd';
import moment from 'moment';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { HEADERMENU_PATH } from '../../../../../routes/RoutesURL';
import { commaSeperator } from '../../../../utils/validation';
import { UpdatePortfolioDoc } from '../../redux/types';
import { getReportColor } from '../../utils';

type Props = {
    list: UpdatePortfolioDoc[];
};

const UpdatePortfolioDocMobile: React.FC<Props> = ({ list }) => {
    const navigate = useNavigate();

    return (
        <div className="w-full">
            {list.length === 0 && (
                <Empty description={`No Portfolio Document Updates`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
            {list.map((item, index) => (
                <div
                    className="px-4 py-2 mb-4"
                    style={{ backgroundColor: '#F5F6FF' }}
                    key={`${item.dealUUID}_${item.investmentUUID}_${index}_${item.obligationDate?.date}_${uuidv4()}`}
                    onClick={() =>
                        navigate(`${HEADERMENU_PATH.investments}/${item.investmentUUID}?tab=document`, {
                            state: { date: item.obligationDate?.date },
                        })
                    }
                >
                    <div className="flex flex-wrap">
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs WorkSans text-[#182D4F]">Reporting Date</p>
                            <p className="text-xs font-normal text-[#20222B]">
                                {moment(item?.obligationDate?.date).format('DD-MMM-YYYY')}
                            </p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Issuer</p>
                            <p className="text-xs font-normal text-[#20222B]">{item.issuerName}</p>
                        </div>
                        <div className="p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Booking</p>
                            <p className="text-xs font-normal text-[#20222B]">
                                {item.reports.length > 0
                                    ? `${
                                          item.reports[0].maturityDate?.date
                                              ? moment(item.reports[0].maturityDate.date).format('DD/MM/YYYY')
                                              : ''
                                      } | ${
                                          item.reports[0]?.amountBorrowed?.amountUpto2dp
                                              ? `${item.reports[0].amountBorrowed.currency} ${commaSeperator(
                                                    parseFloat(
                                                        String(item.reports[0].amountBorrowed.amountUpto2dp || 0),
                                                    ).toFixed(2),
                                                )}`
                                              : ''
                                      } | ${item.reports[0].interestRate ? `${item.reports[0].interestRate}%` : ''}`
                                    : '-'}
                            </p>
                        </div>
                        <div className="w-full p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Document Type</p>
                            <p className="text-xs font-normal text-[#20222B]">
                                {[...item.reports]
                                    .filter(
                                        (a, i, self) =>
                                            self.findIndex((s) => s.obligationType === a.obligationType) === i,
                                    )
                                    ?.map((t, index) => (
                                        <span
                                            className={getReportColor(
                                                t.uploadDetails || [],
                                                item.obligationDate?.date || '',
                                            )}
                                            key={`${index}_${t.obligationType}`}
                                        >
                                            {index === 0 ? `${t.obligationType}` : `, ${t.obligationType}`}
                                        </span>
                                    ))}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UpdatePortfolioDocMobile;
